// extracted by mini-css-extract-plugin
export default {"container":"style_container__8mIDQ","subTitle":"style_subTitle__pI38z","main":"style_main__aR0oE","arrowBtn":"style_arrowBtn__efLKK"};